export default __webpack_public_path__ + "static/ballerina-34b8e5ad87caf5dfeb4323771cae2066.png";